export interface AbsenceTypeClass {
    AccountAbsenceTypeId: number
    AccountId: number
    AbsenceDescription: string
    MasterAccountAbsenceTypeId: number
    IsDisabled: boolean
    AccountAbsenceTypeGuidId: string
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn:  Date | undefined
    ModifiedByEmployeeId: number
    IsDeleted: boolean
    isSelected:number
}

export const absenceTypeInitialsForadd = {
    AbsenceDescription: "",
    IsDisabled: false
}

export const absenceTypeInitialsForUpdate = {
    AbsenceDescription: "",
    AccountAbsenceTypeId: "",
    IsDisabled: false
}